import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class EnvironmentService {

    public selectedEnvironment: any = {};
    private environment = new BehaviorSubject<any>({});

    constructor(private defaultenvironment: any) {
        this.selectedEnvironment = defaultenvironment;
        this.environment.next(this.selectedEnvironment);
    }

    setNew(environment: any) {
        this.selectedEnvironment = environment;
        this.environment.next(environment);
    }

    get(): Observable<any> {
        return this.environment.asObservable();
    }

}